export default "__VITE_ASSET__49857ec3__"